/**
 * Error codes returned by the authentication API.
 */
export const ResponseErrorCodes = {
  /** OTP code entered by user is invalid */
  InvalidOtp: 'InvalidOtp',
  /** Maximum number of OTP verification attempts exceeded */
  TryOtpLimitIsReached: 'TryOtpLimitIsReached',
} as const;

/** Maximum allowed length for phone number input */
export const PHONE_MAX_LENGTH = 16;

/** Number of digits in the OTP code */
export const OTP_CODE_LENGTH = 4;

/** Input mask pattern for OTP field (e.g., '0000' for 4 digits) */
export const OTP_MASK = '0'.repeat(OTP_CODE_LENGTH);
